//-----------------------------------------------
// Lazy Background Videos
//
// background_video() (PHP) outputs <source data-src> instead of src.
// This module activates the variant that is visible at the current
// breakpoint once the block is near the viewport, so hidden
// mobile/desktop variants and below-the-fold videos are never
// downloaded unnecessarily.
//-----------------------------------------------

(function () {
	const wrappers = document.querySelectorAll(".background-video");
	if (!wrappers.length) return;

	const isDisplayed = (el) => el.getClientRects().length > 0;

	const activateVideo = (video) => {
		if (video.dataset.bgLoaded) return;
		const sources = video.querySelectorAll("source[data-src]");
		if (!sources.length) return;
		video.dataset.bgLoaded = "true";
		sources.forEach((source) => {
			source.src = source.dataset.src;
		});
		video.load();
		if (video.dataset.bgAutoplay === "true") {
			const playPromise = video.play();
			if (playPromise && typeof playPromise.catch === "function") {
				playPromise.catch(() => {});
			}
		}
	};

	const activateVisibleVideos = (wrapper) => {
		wrapper.dataset.bgActive = "true";
		Array.from(wrapper.querySelectorAll("video"))
			.filter(isDisplayed)
			.forEach(activateVideo);
	};

	if ("IntersectionObserver" in window) {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					observer.unobserve(entry.target);
					activateVisibleVideos(entry.target);
				});
			},
			{ rootMargin: "200px 0px" },
		);
		wrappers.forEach((wrapper) => observer.observe(wrapper));
	} else {
		wrappers.forEach(activateVisibleVideos);
	}

	// If the breakpoint changes after activation (e.g. rotate/resize),
	// load the variant that has become visible.
	let resizeTimer;
	window.addEventListener("resize", () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			wrappers.forEach((wrapper) => {
				if (wrapper.dataset.bgActive !== "true") return;
				activateVisibleVideos(wrapper);
			});
		}, 250);
	});
})();
